import React from 'react';
import { LifeBuoyIcon } from 'lucide-react';

const SupportAgentHome = () => {
    return (
        <div className="p-4 min-h-screen bg-gray-50 flex flex-col items-center justify-center gap-4">
            <LifeBuoyIcon size={64} className="text-orange-400" />
            <h1 className="text-6xl font-bold">Welcome to Pulse</h1>
            <p className="text-gray-500 font-thin text-2xl">Manage support tickets and meeting rooms</p>
        </div>
    );
};

export default SupportAgentHome;
